module.exports = __webpack_public_path__ + "img/ico-total-ventas.65e8a9e1.svg";